import { useEffect, useRef } from 'react';
import { emitter, EmitterEvent } from '../util/tracking';
import { buildCategoryViewPayload } from '../util/TrackingUtil';
/**
 * Emits a CATEGORY_VIEW tracking event once when category names are resolvable.
 */
export const useCategoryViewTracking = (categoryLevels, sourceId) => {
    const hasFired = useRef(false);
    useEffect(() => {
        if (hasFired.current || !(categoryLevels === null || categoryLevels === void 0 ? void 0 : categoryLevels.length))
            return;
        hasFired.current = true;
        emitter.emit(EmitterEvent.CATEGORY_VIEW, buildCategoryViewPayload(categoryLevels, sourceId));
    }, [categoryLevels, sourceId]);
};
